import Common from "../../../Common";
import Color from "./theme/Color";

export interface WallboardTheme {
	id: id
	class: string
}

const Theme = class extends Common {
	color: InstanceType<typeof Color>;

	constructor(headers: ApiHeaders) {
		super(headers)

		this.color = new Color(headers);
	}

	browse = (companyId: id): CustomResponse<WallboardTheme[]> =>
		this.get(`/company/${companyId}/wallboard/theme`)
}

export default Theme
